import Vue from 'vue';
import VueRouter from 'vue-router';
import MainWrapper from './components/MainWrapper.vue';
import Home from './components/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '',
        component: MainWrapper,
        children: [
            {
                path: '/',
                name: 'home',
                component: Home,
            },
            {
                path: '/code*',
                name: 'home-with-code',
                component: Home,
                meta: { isAuthenticated: true }
            }
        ],
    },
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
});

router.afterEach((toRoute, fromRoute) => {    
    if(process.env.VUE_APP_APPLICATION_MODE == "development") {
        window.document.title = 'WTA PZ | Welcome ' + process.env.VUE_APP_APPLICATION_MODE.toUpperCase();
    }
    else if(process.env.VUE_APP_APPLICATION_MODE == "uat") {
        window.document.title = 'WTA PZ | Welcome QA';
    }
    else {
        window.document.title = 'WTA PZ | Welcome';
    }
});

export default router;
